import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=03e6fa36&scoped=true&"
import script from "./InfoSection.vue?vue&type=script&lang=js&"
export * from "./InfoSection.vue?vue&type=script&lang=js&"
import style0 from "./InfoSection.vue?vue&type=style&index=0&id=03e6fa36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e6fa36",
  null
  
)

export default component.exports